module.exports = __webpack_public_path__ + "static/media/figure-1b.423c44f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-1b.jpg
// module id = 1205
// module chunks = 0